import { render, staticRenderFns } from "./CompanyGroupsTab.html?vue&type=template&id=014a799f&scoped=true&"
import script from "./CompanyGroupsTab.ts?vue&type=script&lang=ts&"
export * from "./CompanyGroupsTab.ts?vue&type=script&lang=ts&"
import style0 from "./CompanyGroupsTab.scss?vue&type=style&index=0&id=014a799f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a799f",
  null
  
)

export default component.exports